import { DateTime } from "luxon";

/**
 * Formats a series conflict occurrence start for the blocked-days table.
 * Uses the user's date and time pattern in the booking timezone.
 */
export function formatSeriesConflictDateTime(
  startIso: string,
  timezone: string,
  dateTimeFormat: string
): string {
  const start = DateTime.fromISO(startIso).setZone(timezone);
  if (start.isValid) {
    return start.toFormat(dateTimeFormat);
  }
  return "";
}
